import { http } from './config/config-receituario'

export default {
  listar: async (token, itens_pagina, pagina, filter) => {
    if ((itens_pagina, pagina)) {
      return http.get(
        'produto-vinculo?itens_pagina=' +
          itens_pagina +
          '&pagina=' +
          pagina +
          '&filter=' +
          encodeURIComponent(filter),
        {
          headers: {
            Authorization: token,
          },
        }
      )
    } else {
      return http.get('produto-vinculo', {
        headers: {
          Authorization: token,
        },
      })
    }
  },
  listarNotFilter: async (token, itens_pagina, pagina) => {
    if ((itens_pagina, pagina)) {
      return http.get(
        `produto-vinculo/filter?take=${itens_pagina}&page=${pagina}`,
        {
          headers: {
            Authorization: token,
          },
        }
      )
    } else {
      return http.get('produto-vinculo', {
        headers: {
          Authorization: token,
        },
      })
    }
  },
  salvar: (token, produto) => {
    return http.post('produto-vinculo', produto, {
      headers: {
        Authorization: token,
      },
    })
  },
  deletar: (token, idProduto) => {
    return http.delete('produto-vinculo/' + idProduto, {
      headers: {
        Authorization: token,
      },
    })
  },
  update: (token, produto) => {
    return http.put('produto-vinculo/' + produto.id_produto_vinculo, produto, {
      headers: {
        Authorization: token,
      },
    })
  },
}
